import axios from 'axios';

const BASE = process.env.REACT_APP_API_URL ?? 'http://localhost:5000';

function ax() {
  return axios.create({ baseURL: BASE, withCredentials: true });
}

export async function apiGet(url) {
  const res = await ax().get(url);
  return res.data;
}

export async function apiPost(url, data) {
  const res = await ax().post(url, data);
  return res.data;
}

export async function apiPut(url, data) {
  const res = await ax().put(url, data);
  return res.data;
}

export async function apiDelete(url) {
  await ax().delete(url);
  return {};
}
